import App from "@/App.vue"
import { filters } from "@/aygulyazilim/helpers"
import { registerPlugins } from "@core/utils/plugins"
import { Buffer } from "buffer"
import { createApp } from "vue"
import Vue3Filters from "vue3-filters"
import DeleteDialog from "@/components/DeleteDialog.vue"

globalThis.Buffer = Buffer

// Styles
import "@core/scss/template/index.scss"
import "@styles/styles.scss"

// Capture PWA install prompt event early
window.deferredPrompt = null
window.addEventListener("beforeinstallprompt", e => {
  e.preventDefault()
  window.deferredPrompt = e

  // console.log("Global beforeinstallprompt captured")
})

// Syncfusion Teması (Vuexy'nin stiliyle uyumlu olması için material temasını seçebiliriz)
// Syncfusion Vue Eklentileri
import { registerLicense } from "@syncfusion/ej2-base"

// Create vue app
const app = createApp(App)

app.component('DeleteDialog', DeleteDialog)

// Registering Syncfusion license key
const SYNCFUSION_LICENSE_KEY =
  "Ngo9BigBOggjHTQxAR8/V1JAaF5cX2pCd1p/TH5YfUNzdUVEY1ZUTXxaS1ZhSXxVdkJhX35ccXJXRGJfVUR9XEY="

registerLicense(SYNCFUSION_LICENSE_KEY)

// import textDirectives from "@/aygulyazilim/directives/text";
// import inputUpper from "@/aygulyazilim/directives/text/inputUpper";
// app.directive("input-upper", inputUpper);
// app.directive("strToUpper", textDirectives.strToUpper);
// app.directive("capitalize", textDirectives.capitalize);
// app.directive("lowerCase", textDirectives.lowerCase);

// Register plugins
registerPlugins(app)

// app.mixin(Vue3Filters.mixin);

app.config.globalProperties.$filters = { ...Vue3Filters.filters, ...filters }

// .env dosyasındaki VITE_API_BASE_URL değişkenini global olarak tanımlıyoruz
app.config.globalProperties.$config = {
  apiBaseUrl: import.meta.env.VITE_API_ENDPOINT.endsWith("/")
    ? import.meta.env.VITE_API_ENDPOINT
    : import.meta.env.VITE_API_ENDPOINT + "/",
}

// Mount vue app
app.mount("#app")

// Service Worker Kaydı
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/sw.js')
    .then(reg => console.log('Service Worker registered!'))

    // .then(reg => console.log('Service Worker registered!', reg))
    // .catch(err => console.error('Service Worker registration failed:', err))
    .catch(err => console.error('Service Worker registration failed!'))
}
